import type React from 'react';
import { useState } from 'react';

import { Modal } from '@kathondvla/react-shared-components/src/components';

import PersonPicker from '@UI/personPicker/PersonPicker';
import type { IApiResouce } from '@generalTypes/sriTypes';
import { closeAddItemReferenceModal } from '@newStore/documentUI/documentUIState';
import { NodeType } from '@nodeTypeConfig/configTypes';
import { singleContactComponent } from '@nodeTypeConfig/helpers/editComponents/proContactsComponent';
import { addNodeToParentNodeAction, addRelationAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { useDispatch } from 'react-redux';
import uuidv4 from 'uuid/v4';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { EventsDropdown } from './EventsDropdown';
import './modals.scss';

const referenceConfig = {
  [NodeType.PERSON_REFERENCE]: {
    title: 'Toevoegen persoon',
  },
  [NodeType.PRO_NEWSLETTER_EVENT]: {
    title: 'Toevoegen training',
  },
};

const ItemReferenceInsertModal: React.FC<Record<string, never>> = () => {
  const [selectedReference, setSelectedReference] = useState<string | null>(null);

  const dispatch = useDispatch();

  const modalData = useTypedSelector((state) => state.documentUI.addItemReferenceModalData.data);

  const onItemChange = (value: Array<IApiResouce> | IApiResouce) => {
    const hrefs = Array.isArray(value)
      ? value.map((item) => item.$$meta.permalink)
      : [value.$$meta.permalink];
    setSelectedReference(hrefs[0]);
  };

  const handleSubmit = () => {
    if (selectedReference && modalData) {
      const referenceKey = uuidv4();
      dispatch(
        addNodeToParentNodeAction(
          getResourceKey(modalData.parentHref),
          modalData.positionIndex,
          modalData.nodeType,
          undefined,
          referenceKey,
        ),
      );

      const newRelation = {
        relationtype: 'REFERENCES',
        strength: 'MEDIUM',
        from: {
          href: `/content/${referenceKey}`,
        },
        to: {
          href: selectedReference,
        },
      };

      dispatch(addRelationAction(newRelation, true, true));
    }

    dispatch(closeAddItemReferenceModal());
  };

  const onClose = () => {
    dispatch(closeAddItemReferenceModal());
  };

  if (!modalData) {
    return null;
  }

  return (
    <div className="overflown-modal">
      <Modal.Header title={referenceConfig[modalData.nodeType].title} onClose={onClose} />
      <Modal.Body>
        <div className="form-group">
          {modalData.nodeType === NodeType.PERSON_REFERENCE && (
            <PersonPicker
              config={singleContactComponent}
              readonly={false}
              onChange={onItemChange}
            />
          )}
          {modalData.nodeType === NodeType.PRO_NEWSLETTER_EVENT && (
            <EventsDropdown onChange={onItemChange} />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

ItemReferenceInsertModal.displayName = 'PersonReferenceInsertModal';

export default ItemReferenceInsertModal;
